import { render, staticRenderFns } from "./RegQuery.vue?vue&type=template&id=4a506a61&scoped=true"
import script from "./RegQuery.vue?vue&type=script&lang=js"
export * from "./RegQuery.vue?vue&type=script&lang=js"
import style0 from "./RegQuery.vue?vue&type=style&index=0&id=4a506a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a506a61",
  null
  
)

export default component.exports